import {useEffect} from 'react';
import {addLifeCycleListener, LifeCycleState, removeLifeCycleListener} from '@cci-shared/features/webviewHook';

export function useBottomSheetPage() {
  useEffect(() => {
    addLifeCycleListener(appLifeCycleListener);

    return () => {
      removeLifeCycleListener(appLifeCycleListener);
    };
  }, []);
}

function appLifeCycleListener(state: LifeCycleState) {
  if (state === LifeCycleState.DESTROY) {
    removeLifeCycleListener(appLifeCycleListener);
    (window as any).bottomSheetClose(false);
  }
}
